import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AddUserModel } from './user-details.model';
import { UserManagementService } from '../user-management.service';
import { EnumModel } from '../../shared/objects/EnumModel';
import { GroupDetailsVenueModel } from '../../venues/create-group/create-group.model';

@Component({
  selector: 'app-add-user',
  templateUrl: './add-user.component.html',
  providers: [UserManagementService],
  styleUrls: ['./add-user.component.less']
})
export class AddUserComponent implements OnInit {
  @Input() addNewUser: boolean;
  @Input() fromGroupDatabase: boolean;
  @Input() venues: GroupDetailsVenueModel[];
  @Output() addNewUserChange = new EventEmitter<boolean>();
  @Output() addUserChange = new EventEmitter();

  showError = false;
  errorInfo = '';

  optionsDropdown: EnumModel[] = [];
  optionsVenuesDropdown: EnumModel[] = [];
  selectedOptionDropdown = new EnumModel();
  selectedOptionVenuesDropdown = new EnumModel();
  addUserModel = new AddUserModel();
  buttonsEnabled = true;
  focus: boolean;

  constructor(private userManagementService: UserManagementService) {
  }

  ngOnInit() {
    if (this.fromGroupDatabase) {
      this.optionsDropdown.push(new EnumModel('GroupDashboard', 'Group Dashboard'));
      this.optionsDropdown.push(new EnumModel('VenueDashboard', 'Venue Dashboard'));
      this.selectedOptionDropdown = this.optionsDropdown[0];

      for (let venue of this.venues) {
        this.optionsVenuesDropdown.push(new EnumModel(venue.id, venue.name));
      }
      this.selectedOptionVenuesDropdown = this.optionsVenuesDropdown[0];
    }
  }

  close() {
    this.addNewUserChange.emit(false);
  }

  closeX() {
    if (this.buttonsEnabled) {
      this.addNewUserChange.emit(false);
    }
  }

  addUser() {
    this.buttonsEnabled = false;

    if (this.fromGroupDatabase) {
      if (this.addUserModel.isAdmin) {
        if (this.selectedOptionDropdown.id === 'GroupDashboard') {
          this.addUserModel.role = 5;
        } else {
          this.addUserModel.role = 3;
        }
      } else {
        if (this.selectedOptionDropdown.id === 'GroupDashboard') {
          this.addUserModel.role = 6;
        } else {
          this.addUserModel.role = 4;
        }
      }
    } else {
      if (this.addUserModel.isAdmin) {
        this.addUserModel.role = 1;
      } else {
        this.addUserModel.role = 2;
      }
    }


    this.addUserModel.venueId = this.selectedOptionVenuesDropdown ? this.selectedOptionVenuesDropdown.id : null;

    if (this.fromGroupDatabase) {
      this.addUserChange.emit(this.addUserModel);
      this.close();
    } else {
      this.userManagementService.addUser(this.addUserModel)
        .subscribe(
          (response) => {
            this.addUserChange.emit('userManagement');
            this.close();
          },
          (error) => {
            this.showError = true;
            this.errorInfo = error;
            this.buttonsEnabled = true;
          }
        );
    }
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/user-management/user-details/add-user.component.ts